const API_URL = process.env.REACT_APP_BACKEND_URL;
const CHUNK_SIZE = 4 * 1024 * 1024;
export const MAX_UPLOAD_MB = 200;

export const mediaSrc = (url) => (url?.startsWith('/api/') ? `${API_URL}${url}` : url);

export const parseEmbed = (link) => {
  const yt = link.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vimeo = link.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
};

export const uploadMedia = async (file, { token, propertyId, onProgress }) => {
  if (file.size > MAX_UPLOAD_MB * 1024 * 1024) throw new Error(`File is larger than ${MAX_UPLOAD_MB}MB`);
  if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) throw new Error('Only photos and videos are allowed');
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.ceil(file.size / CHUNK_SIZE);
  for (let i = 0; i < total; i++) {
    const form = new FormData();
    form.append('upload_id', uploadId);
    form.append('index', String(i));
    form.append('chunk', file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
    const res = await fetch(`${API_URL}/api/admin/media/chunk`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: form });
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || 'Chunk upload failed');
    onProgress?.(Math.round(((i + 1) / total) * 90));
  }
  const res = await fetch(`${API_URL}/api/admin/media/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ upload_id: uploadId, filename: file.name, content_type: file.type, total_chunks: total, property_id: propertyId }),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || 'Upload failed');
  onProgress?.(100);
  return res.json();
};
